/* ***************************************************************************
 * @flow
 * @author Afonso Bordado (abordado@mobinteg.com)
 *
 * This file handles the socket connections used in some parts of the site
 *******************************************************************************/

import React, { Component } from "react"
import { connect } from "react-redux"
import {
  API_URL,
  jobLogUpdate,
  jobProgressUpdate,
  jobUpdate,
  jobAdd,
} from "../actions"
import io from "socket.io-client"

class SocketConnection extends Component {
  props: {
    dispatch: any,
    auth: any,
    jobProgressUpdate: any,
    jobLogUpdate: any,
    jobUpdate: any,
    jobAdd: any,
  }

  state: {
    socket: undefined,
  }

  componentDidMount () {
    const socket = io( API_URL, {
      transports: [ "websocket" ],
      query: {
        token: this.props.auth.token,
      },
    } )


    socket.on( "connect", () => {} )

    socket.on( "message", ( type, value ) => {
      if ( type === "jobProgress" ) {
        this.props.jobProgressUpdate( value.id, value.progress )
      } else if ( type === "jobLog" ) {
        this.props.jobLogUpdate( value.id, value.log )
      } else if ( type === "jobAdd" ) {
        this.props.jobAdd( value )
      } else if ( type === "jobUpdate" ) {
        this.props.jobUpdate( value )
      }
    } )

    this.setState( {
      socket,
    } )
  }

  componentWillUnmount () {
    const socket = this.state.socket
    socket.disconnect()
  }


  render () {
    return <div/>
  }
}

const mapStateToProps = ( store ) => {
  return {
    jobs: store.jobs,
    auth: store.auth,
  }
}

export default connect( mapStateToProps, {
  jobProgressUpdate,
  jobLogUpdate,
  jobAdd,
  jobUpdate,
} )( SocketConnection )




// WEBPACK FOOTER //
// ./src/components/Socket.jsx